// extracted by mini-css-extract-plugin
export var article = "Article-module--article--tidny";
export var articleImage = "Article-module--article-image---3Lbo";
export var articleText = "Article-module--article-text--qfMaf";
export var articleTitle = "Article-module--article-title--P5JYX";
export var publishedAt = "Article-module--published-at--zjICL";
export var readMore = "Article-module--read-more--8s80T";
export var readMoreTextWrap = "Article-module--read-more-text-wrap--3Alcm";
export var readMoreWrapper = "Article-module--read-more-wrapper--pag6Z";